interface SubjectProps {
  subject: string;
}

const SubjectLine = ({ subject }: SubjectProps) => (
  <h3 className="text-center font-bold underline mb-4 text-[11px]" style={{fontFamily: "Times New Roman"}}>
    {subject.toUpperCase()}
  </h3>
);

export default SubjectLine;
